import { useBillsListFilters } from './useBillsListFilters'
import { useFetchBillsSummary } from './useFetchBillsSummary'

export const useBillsSummaryFiltered = () => {
  const [{ contactId, period, searchQuery, status }] = useBillsListFilters()

  return useFetchBillsSummary({ contactId, period, searchQuery, status })
}
